/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : requestAccess.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomTabsV2 from "../../components/customComponentsV2/common/tabs/CustomTabsV2";
import LogsTab from "../../components/customComponentsV2/vlc/pages/LogsTab";
// import appTheme from "../../config/appTheme";
import CustomFormTextFieldV2 from "../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import appTheme from "../../assets/app-theme/appTheme";

function RequestsAndLogsTabs({
  getRequestsData = [],
  getStatusLabel,
  reason,
  setReason,
  reasonError,
  setReasonError,
  handleSubmit,
  ChangeLogsList,
  totalLogsCount,
  onClose,
  selectedProjectDetails,
  data,
}) {
  const [expandLogs, setExpandLogs] = useState(false);
  return (
    <Box sx={{ width: "100%" }}>
      <CustomTabsV2
        tabs={[
          {
            name: "Requests",
            content:
              getRequestsData?.[0]?.status === 100 ? (
                "Request already sent and pending for approval"
              ) : (
                <>
                  {/*{data?.is_edit_enabled ||
                // selectedProjectDetails?.is_user_project_owner ? ( */}
                  <Box sx={{ p: 2 }}>
                    {/* ===== Request Access Form ===== */}
                    <Typography fontWeight={600} mb={1}>
                      Request Access
                    </Typography>

                    <CustomFormTextFieldV2
                      size="small"
                      required={true}
                      label="Reason"
                      // placeholder="Reason for request"
                      type="text"
                      fldType="text5"
                      value={reason}
                      // setValue={setReason}
                      setValue={(value) =>
                        value.length <= 100 && setReason(value)
                      }
                      valueError={reasonError}
                      setValueError={setReasonError}
                      maxLength={100}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        justifyContent: "flex-end",
                        mt: 2,
                      }}
                    >
                      <CustomButtonV2
                        handleOnClick={onClose}
                        sx={{ ...appTheme.commonBtnStyle }}
                        btnName="Close"
                        type="cancel"
                      />
                      <CustomButtonV2
                        handleOnClick={handleSubmit}
                        disabled={reason?.length < 5}
                        btnName="Send"
                        type="submit"
                      />
                    </Box>
                  </Box>
                  {/* // ) : (
                //   <Typography sx={{ p: 2 }}>
                //     You do not have permission to request access.
                //   </Typography>
                // )} */}
                </>
              ),
          },
          {
            name: "Logs",
            // count: totalLogsCount || 0,
            content: (
              <>
                {/* <LogsTab
                  logs={ChangeLogsList}
                  expanded={expandLogs}
                  setExpanded={setExpandLogs}
                /> */}
                {/* ===== Requests Table ===== */}
                {getRequestsData.length > 0 ? (
                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <strong>S.No</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Reason</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Status</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Requestor</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Created At</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Updated At</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {getRequestsData.map((request, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{request.request_reason}</TableCell>
                            <TableCell>
                              {getStatusLabel(request.status)}
                            </TableCell>
                            <TableCell>
                              {request?.requested_user?.fullname || "-"}
                            </TableCell>
                            <TableCell>
                              {new Date(request.created_at).toLocaleString()}
                            </TableCell>
                            <TableCell>
                              {new Date(request.updated_at).toLocaleString()}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography>No requests available.</Typography>
                )}
              </>
            ),
          },
        ]}
      />
    </Box>
  );
}

export default RequestsAndLogsTabs;
